<template>
  <div class="bg-container">
    <div class="feedback-page">
      <div class="section">
        <h2>
          <font dir="auto" style="vertical-align: inherit">
            <font dir="auto" style="vertical-align: inherit"
              ><font dir="auto" style="vertical-align: inherit"
                ><font
                  dir="auto"
                  style="vertical-align: inherit; color: #f3c7a2"
                  >{{ $t("q116") }}</font
                ></font
              ></font
            >
          </font>
        </h2>
        <div class="features">
          <div class="feature">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path
                d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41 0.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
              ></path>
            </svg>
            <h3>
              <font dir="auto" style="vertical-align: inherit">
                <font dir="auto" style="vertical-align: inherit"
                  ><font dir="auto" style="vertical-align: inherit"
                    ><font dir="auto" style="vertical-align: inherit">{{
                      $t("q117")
                    }}</font></font
                  ></font
                >
              </font>
            </h3>
            <p>
              <font dir="auto" style="vertical-align: inherit">
                <font dir="auto" style="vertical-align: inherit"
                  ><font dir="auto" style="vertical-align: inherit"
                    ><font dir="auto" style="vertical-align: inherit">{{
                      $t("q118")
                    }}</font></font
                  ></font
                >
              </font>
            </p>
          </div>
          <div class="feature">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path
                d="M20 2H4C2.9 2 2 2.9 2 4v16l4-4h14c1.1 0 2-0.9 2-2V4c0-1.1-0.9-2-2-2z"
              ></path>
            </svg>
            <h3>
              <font dir="auto" style="vertical-align: inherit">
                <font dir="auto" style="vertical-align: inherit"
                  ><font dir="auto" style="vertical-align: inherit"
                    ><font dir="auto" style="vertical-align: inherit">{{
                      $t("q119")
                    }}</font></font
                  ></font
                >
              </font>
            </h3>
            <p>
              <font dir="auto" style="vertical-align: inherit">
                <font dir="auto" style="vertical-align: inherit"
                  ><font dir="auto" style="vertical-align: inherit"
                    ><font dir="auto" style="vertical-align: inherit">{{
                      $t("q120")
                    }}</font></font
                  ></font
                >
              </font>
            </p>
          </div>
          <div class="feature">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path
                d="M12 17a2 2 0 100-4 2 2 0 000 4zm6.6-9.2l-1.4-1.4L12 10.6 6.8 6.4 5.4 7.8 12 14.4l6.6-6.6z"
              ></path>
            </svg>
            <h3>
              <font dir="auto" style="vertical-align: inherit">
                <font dir="auto" style="vertical-align: inherit"
                  ><font dir="auto" style="vertical-align: inherit"
                    ><font dir="auto" style="vertical-align: inherit">{{
                      $t("q121")
                    }}</font></font
                  ></font
                >
              </font>
            </h3>
            <p>
              <font dir="auto" style="vertical-align: inherit">
                <font dir="auto" style="vertical-align: inherit"
                  ><font dir="auto" style="vertical-align: inherit"
                    ><font dir="auto" style="vertical-align: inherit"
                      >{{ $t("q122") }}
                    </font></font
                  ></font
                >
              </font>
            </p>
          </div>
        </div>
      </div>
      <div class="title">
        {{ $t("q115") }}
      </div>

      <div
        class="scroll-wrapper"
        @mouseenter="pause"
        @mouseleave="play"
        @touchstart="pause"
        @touchend="play"
        @touchcancel="play"
      >
        <div class="scroll-content" :style="styleObj">
          <div class="card" v-for="item in showList" :key="item.uuid">
            <div class="name">
              {{ item.name }}
            </div>

            <div class="content">
              {{ item.commentText }}
            </div>
          </div>
        </div>
      </div>

      <div class="bottom">
        <van-button round color="#ff5b86" @click="comment">
          {{ $t("q114") }}
        </van-button>
      </div>
      <van-popup
        v-model="showComment"
        position="bottom"
        round
        :style="{ height: '320px' }"
      >
        <div class="comment-box">
          <div class="comment-title">
            {{ $t("q113") }}
          </div>

          <van-field
            v-model="commentText"
            class="comment-field"
            rows="6"
            autosize
            type="textarea"
            maxlength="300"
            :placeholder="$t('q112')"
            show-word-limit
          />
          <div class="toolbar">
            <span class="emoji-btn" @click="showEmoji = !showEmoji"> 😊 </span>
          </div>

          <div class="emoji-panel" v-show="showEmoji">
            <span v-for="item in emojis" :key="item" @click="addEmoji(item)">
              {{ item }}
            </span>
          </div>
          <van-button block round color="#ff5b86" @click="submitComment">
            {{ $t("q111") }}
          </van-button>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    const list = [
      // {
      //   id:1,
      //   name:"林先生",
      //   content:"一开始只是抱着试试看的心态注册，没想到真的遇到了聊得来的人。我们聊了两三天后就约出来喝咖啡，见面后发现和聊天时一样真诚，没有任何尴尬，现在已经认识一个多月了。"
      // },
      // {
      //   id:2,
      //   name:"WitLong",
      //   content:"之前下载过很多类似的软件，大部分不是机器人就是广告。这次体验确实不一样，附近的人回复速度快，聊天也很自然，现在已经交换了联系方式。"
      // },
      // {
      //   id:3,
      //   name:"Jason",
      //   content:"实名认证以后感觉用户质量确实高了不少，没有遇到机器人，也没有骚扰消息，希望平台以后继续保持这种审核机制。"
      // },
      // {
      //   id:4,
      //   name:"Lucky",
      //   content:"刚开始只是随便看看，结果认识了一位距离我不到五公里的女生。聊了一周后第一次见面，感觉非常自然，现在已经成为了好朋友。"
      // },
      // {
      //   id:5,
      //   name:"David",
      //   content:"客服回复速度很快，遇到问题基本都能及时解决。聊天体验不错，没有广告，也没有强制收费，整体体验超出了我的预期。"
      // }
    ];

    return {
      list,

      showList: [
        ...list.map((i) => ({ ...i, uuid: i.id + "a" })),
        ...list.map((i) => ({ ...i, uuid: i.id + "b" })),
      ],

      offset: 0,

      timer: null,

      speed: 0.5,
      showComment: false,

      commentText: "",
      showEmoji: false,

      emojis: [
        "😀",
        "😁",
        "😂",
        "🤣",
        "😅",
        "😊",
        "😍",
        "😘",
        "🥰",
        "😎",
        "🤩",
        "🤔",
        "😭",
        "😡",
        "😱",
        "🤭",
        "👍",
        "👏",
        "🙏",
        "💪",
        "👌",
        "✌️",
        "🤝",
        "❤️",
        "💖",
        "💕",
        "💞",
        "💘",
        "💯",
        "🔥",
        "🎉",
        "🌹",
        "🎁",
        "🍺",
        "🍻",
        "☕",
        "🍎",
        "🍉",
        "🍓",
        "🥂",
        "🎂",
        "🎈",
        "💐",
        "🍀",
        "🐶",
        "🐱",
        "🐼",
        "🌈",
      ],
    };
  },

  computed: {
    styleObj() {
      return {
        transform: `translateY(-${this.offset}px)`,
      };
    },
  },

  mounted() {
    this.listComment();
    this.play();
  },

  beforeDestroy() {
    cancelAnimationFrame(this.timer);
  },

  methods: {
    play() {
      if (this.timer) return;

      const run = () => {
        this.offset += this.speed;

        const h = this.$refsHeight();

        if (this.offset >= h) {
          this.offset = 0;
        }

        this.timer = requestAnimationFrame(run);
      };

      run();
    },

    pause() {
      cancelAnimationFrame(this.timer);

      this.timer = null;
    },

    $refsHeight() {
      return document.querySelector(".scroll-content").scrollHeight / 2;
    },

    comment() {
      this.showComment = true;
    },
    addEmoji(emoji) {
      this.commentText += emoji;
    },
    listComment() {
      this.$http({
        method: "get",
        url: "commentList",
      })
        .then((res) => {
          this.list = res.data2;
          this.showList.push(
            ...res.data2.map((i) => ({ ...i, uuid: i.id + "a" }))
          );
          this.showList.push(
            ...res.data2.map((i) => ({ ...i, uuid: i.id + "b" }))
          );
        })
        .catch(() => {
          this.$toast(this.$t("q110"));
        });
    },
    submitComment() {
      if (!this.commentText.trim()) {
        this.$toast(this.$t("q109"));

        return;
      }

      console.log(this.commentText);

      // TODO 调接口
      this.$http({
        method: "post",
        url: "comment",
        data: { commentText: this.commentText },
      })
        .then(() => {
          this.$toast(this.$t("q107"));

          this.showComment = false;

          this.commentText = "";

          this.showEmoji = false;
          this.listComment();
        })
        .catch(() => {
          this.$toast(this.$t("q108"));
        });
    },
  },
};
</script>

<style scoped lang="scss">
.comment-field >>> textarea {
  font-size: 24px;

  line-height: 38px;

  min-height: 180px;
}

.toolbar {
  display: flex;

  justify-content: flex-end;

  margin-top: 10px;
}

.emoji-btn {
  font-size: 42px;

  cursor: pointer;
}

.emoji-panel {
  display: flex;

  flex-wrap: wrap;

  margin-top: 15px;

  background: #fafafa;

  border-radius: 12px;

  padding: 12px;

  max-height: 200px;

  overflow-y: auto;
}

.emoji-panel span {
  width: 12.5%;

  text-align: center;

  font-size: 34px;

  line-height: 56px;

  cursor: pointer;

  transition: 0.2s;
}

.emoji-panel span:active {
  transform: scale(1.3);
}

.comment-box {
  padding: 25px;
}
.comment-field {
  font-size: 25px;
}
.comment-title {
  text-align: center;

  font-size: 25px;

  font-weight: bold;

  margin-bottom: 20px;
}

.comment-box .van-button {
  /* width:300px; */

  height: 60px;

  font-size: 25px;
  margin-top: 20px;
}
.feedback-page {
  // background: linear-gradient(
  //   90deg,
  //   #3882b0,
  //   #a8197a,
  //   #541349,
  //   #541950,
  //   #541851
  // );
background: rgb(31, 28, 31);
  min-height: 100vh;

  padding: 30PX 20PX 120PX;

  box-sizing: border-box;
}

.title {
  text-align: center;
  color: #f3c7a2;
  font-size: 36px;

  font-weight: bold;

  margin-bottom: 30px;
  @media screen and (min-width: 1024px) {
    margin-bottom: 15px;
    font-size: 18px;
  }
}

.scroll-wrapper {
  height: 50vh;

  overflow: hidden;

  position: relative;
}

.scroll-content {
  will-change: transform;
}

.card {
  background: #fff;

  border-radius: 18px;
  margin-bottom: 18px;
  padding: 24px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  @media screen and (min-width: 1024px) {
    border-radius: 9px;
    margin-bottom: 9px;
    padding: 12px;
  }
}

.name {
  color: #ff4d79;
  font-size: 30px;
  font-weight: bold;
  margin-bottom: 15px;
  @media screen and (min-width: 1024px) {
     font-size: 15px;
    margin-bottom: 8px;
  }
}

.content {
  line-height: 1.9;

  color: #444;

  font-size: 24px;

  @media screen and (min-width: 1024px) {
    font-size: 12px;
  }
}

.bottom {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
}

.bottom .van-button {
  width: 300px;
  height: 60px;
  font-size: 25px;
  @media screen and (min-width: 1024px) {
    width: 150px;
    height: 30px;
    font-size: 13px;
  }
}
.section {
  padding: 30PX 15PX;
  text-align: center;
}
.features {
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  @media screen and (min-width: 1024px) {
    .feature svg {
      width: 21px;
      height: 21px;
      margin-bottom: 4px;
      fill: #ff4081;
    }
    .feature h3 {
      font-size: 13px;
      margin: 5px 0;
    }
    .feature p {
      font-size: 13px;
      color: #ff4081;
    }
  }
}
.feature {
  flex: 1;
  margin: 0 5PX;
  background: #fff;
  padding: 15PX;
  border-radius: 15PX;
  box-shadow: 0 3PX 10PX #0000000f;

  
}

.feature svg {
  width: 40px;
  height: 40px;
  margin-bottom: 8px;
  fill: #ff4081;
}
.feature h3 {
  font-size: 25px;
  margin: 8px 0;
}
.feature p {
  font-size: 25px;
  color: #ff4081;
}
</style>